import React from "react";
import "./Pagination.css";

interface PaginationProps {
	currentPage: number;
	totalItems: number;
	pageSize?: number;
	onChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalItems, pageSize = 15, onChange }) => {
	const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));

	const goTo = (page: number) => {
		const clamped = Math.min(Math.max(1, page), totalPages);
		if (clamped !== currentPage) onChange(clamped);
	};

	const pagesToRender = () => {
		const pages: number[] = [];
		const maxButtons = 7;
		if (totalPages <= maxButtons) {
			for (let i = 1; i <= totalPages; i++) pages.push(i);
			return pages;
		}
		const start = Math.max(1, currentPage - 2);
		const end = Math.min(totalPages, start + 4);
		for (let i = start; i <= end; i++) pages.push(i);
		if (!pages.includes(1)) pages.unshift(1);
		if (!pages.includes(totalPages)) pages.push(totalPages);
		return pages;
	};

	return (
		<div className="Pagination">
			<button className="Pagination-Btn" onClick={() => goTo(currentPage - 1)} disabled={currentPage <= 1}>Précédent</button>
			<div className="Pagination-Pages-Wrapper">
				<div className="Pagination-Pages">
					{pagesToRender().map((p, idx, arr) => {
						const prev = idx > 0 ? arr[idx - 1] : undefined;
						const showEllipsis = prev !== undefined && p - prev > 1;
						return (
							<React.Fragment key={p}>
								{showEllipsis && <span className="Pagination-Ellipsis">…</span>}
								<button
									className={`Pagination-Page ${p === currentPage ? "active" : ""}`}
									onClick={() => goTo(p)}
								>
									{p}
								</button>
							</React.Fragment>
						);
					})}
				</div>
			</div>
			<button className="Pagination-Btn" onClick={() => goTo(currentPage + 1)} disabled={currentPage >= totalPages}>Suivant</button>
			<div className="Pagination-Info">Page {currentPage} / {totalPages}</div>
		</div>
	);
};

export default Pagination;


